import { render } from "./StatusesCheckBox.vue?vue&type=template&id=ef1e1ae0"
import script from "./StatusesCheckBox.vue?vue&type=script&lang=js"
export * from "./StatusesCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\FomoFront\\VindFrontFomoApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QCheckbox});
